export const live = {
    zbz: "En direct",
    ljks: "Commencer maintenant",
    hmyzb: "Vous n'avez pas encore streamé ~",
    zbyg: "Annonce du direct",
    yjs: "Terminé",
    jszb: "Terminer le direct",
    gbzb: "Fermer le direct",
    jxzb: "Continuer le direct",
    bctp: "Enregistrer l'image",
    fxlj: "Partager le lien",
    zbydk: "Connexion perdue, veuillez patienter...",
    fh: "RETOUR",
    wjcdypsb: "Aucun périphérique audio détecté",
    czsb: "Échec de l'opération Canvas :",
    tpjzsb: "Échec du chargement de l'image, vérifiez l'URL",
    zbjl: "Historique des directs",
    sqjl: "Historique des demandes",
    lts: "Salon de chat",
    ren: "personnes",
    gdcy: "Plus de membres",
    cy: "membre",
    jcjy: "Lever l'interdiction",
    jy: "Interdire",
    qbjy: "Interdire tout",
    zbjs: "Présentation du direct",
    srnr: "Veuillez entrer le contenu",
    tczbj: "Vous avez été expulsé du direct",
    qd: "CONFIRMER",
    zbjjjs: "Votre direct se terminera automatiquement dans 10 minutes !",
    zbsc: "Durée du direct :",
    ljgkrs: "Spectateurs cumulés :",
    dzs: "J'aime :",
    zbjies: "Fin du direct",
    ybjy: "Vous avez été réduit au silence",
    jycg: "Interdiction levée",
    jinycg: "Interdiction réussie",
    qbjinycg: "Interdiction générale réussie",
    qbjycg: "Levée générale réussie",
    cwzb: "Devenir streamer",
    lxgzry: "Veuillez contacter le personnel pour devenir streamer",
    lxfs: "Coordonnées",
    zb: "Direct",
    xkt: "Biking Academy",
    sqzb: "Demander un direct",
    bczbzt: "Sujet de ce direct",
    srzt: "Veuillez entrer le sujet",
    bczbjj: "Résumé du direct",
    kbsj: "Heure de début",
    xzrisj: "Sélectionner date et heure",
    tishi: "Astuce",
    dksdzb: "Il y a 1 direct prévu à cette heure",
    cxsj: "Durée",
    xzsc: "Sélectionner la durée",
    fmt: "Image de couverture",
    fmtbnwk: "L'image de couverture ne peut pas être vide",
    sc: "Télécharger",
    yssc: "Maximum 10MB, compressez avant de télécharger",
    sccct: "Veuillez télécharger une image 360*170",
    tjsq: "Soumettre la demande",
    tpcj: "Recadrage de l'image",
    tzcjwz: "Ajustez la position du cadre",
    scdtp: "Image téléchargée",
    yl: "Aperçu (360×170)",
    cjtp: "Recadrer",
    quxiao: "Annuler",
    qsrzbjj: "Veuillez entrer le résumé du direct",
    qxzrq: "Veuillez sélectionner une date",
    qxzsc: "Veuillez sélectionner une durée",
    kssjdydqsj: "L'heure de début doit être postérieure à l'heure actuelle",
    sctxtpdx: "La taille de l'image ne peut pas dépasser 10MB!",
    tjcg: "Soumission réussie",
    jkshnr: "Nous examinerons votre demande rapidement",
    hmysqgzb: "Vous n'avez pas encore fait de demande de direct ~",
    shz: "En attente d'approbation",
    tongg: "Approuvé",
    jujue: "Refusé",
    yugao: "Annonce",
    huifang: "Replay",
}


// WEBPACK FOOTER //
// ./src/i18n/lang/live/fr.js